<template>
  <modal
    name="modal--edit-fees"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="400"
    :height="'auto'"
    :adaptive="true"
    :reset="true"
    :scrollable="true"
    draggable=".drag-handler"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    class="py-10"
  >
    <div
      class="flex flex-col text-black h-full overflow-hidden w-full bg-white rounded-sm justify-between p-4"
    >
      <div
        class="text-center text-4xl mb-8 font-extralight tracking-tight drag-handler"
      >
        Default Fee Values
      </div>

      <div class="text-xl">
        <form @submit.prevent="handleConfirm">
          <div class="flex flex-row justify-between mb-1">
            <label class="w-2/3 justify-center pr-4 flex items-center truncate">
              Payroll Taxes & Benefits
            </label>
            <div
              class="mx-1 w-1/3 text-center text-base font-normal normal-case focus:outline-none focus:shadow-outline appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 pr-10 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            >
              <input
                class="appearance-none bg-transparent text-center leading-tight w-full"
                autocomplete="off"
                v-model="data.feesPayroll"
                :disabled="!isAdmin"
              />
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500 font-bold"
              >
                %
              </div>
            </div>
          </div>
          <div class="mt-4 flex flex-row justify-between mb-1">
            <label class="w-2/3 justify-center pr-4 flex items-center truncate">
              Average Delivery Fees
            </label>
            <div
              class="mx-1 w-1/3 text-center text-base font-normal normal-case focus:outline-none focus:shadow-outline appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 pr-10 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            >
              <input
                class="appearance-none bg-transparent text-center leading-tight w-full"
                autocomplete="off"
                v-model="data.feesDelivery"
                :disabled="!isAdmin"
              />
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500 font-bold"
              >
                %
              </div>
            </div>
          </div>
          <div class="button-set flex flex-row justify-between mt-10">
            <button
              class="buttonOutline focus:shadow-outline focus:outline-none"
              @click.prevent="$modal.hide('modal--edit-fees')"
            >
              Cancel
            </button>

            <button
              v-if="isAdmin"
              class="button focus:shadow-outline focus:outline-none"
              type="submit"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalEditFees',
  data() {
    return {
      data: {
        feesPayroll: null,
        feesDelivery: null
      }
    }
  },
  computed: {
    ...mapGetters('storeModule', ['deliveryFee', 'payrollTax']),
    ...mapGetters('user', ['isAdmin'])
  },
  methods: {
    ...mapActions('config', ['setFabVisible', 'setDragLock']),
    ...mapActions('storeModule', ['updateItem']),
    beforeOpen() {
      this.data.feesPayroll = this.payrollTax || 0
      this.data.feesDelivery = this.deliveryFee || 0
      this.setFabVisible(false)
      this.setDragLock(true)
    },
    beforeClose() {
      this.setFabVisible(true)
      this.setDragLock(false)
    },
    handleConfirm() {
      if (this.deliveryFee != this.data.feesDelivery)
        this.updateItem({ deliveryFee: this.data.feesDelivery })
      if (this.payrollTax != this.data.feesPayroll)
        this.updateItem({ payrollTax: this.data.feesPayroll })
      this.$modal.hide('modal--edit-fees')
    }
  }
}
</script>
